import { Icon, P } from '@mxenabled/mxui'

import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import { type SxProps } from '@mui/material/styles'

export interface TipSectionProps {
  message: React.ReactNode
  tipAriaLabel?: string
  onDismiss?: () => void
  onAction?: () => void
  sx?: SxProps
}

export const TipSection = ({ message, tipAriaLabel, onDismiss, onAction, sx }: TipSectionProps) => {
  // Priority: action > dismiss > nothing
  const buttonHandler = onAction || onDismiss
  const iconName = onAction ? 'chevron_right' : 'close'

  return (
    <Stack
      sx={{
        backgroundColor: 'primary.lighter',
        borderRadius: '8px',
        mb: 24,
        mt: 12,
        p: 12,
        mx: 24,
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexDirection: 'row',
        gap: 8,
        ...sx,
      }}
    >
      <Stack sx={{ flexDirection: 'row', gap: 4 }}>
        <Icon color="info" fill={true} name="lightbulb" size={24} />
        <P color="primary.dark" fontWeight={400} noWrap={false} variant="subtitle2">
          {message}
        </P>
      </Stack>

      {buttonHandler && (
        <IconButton
          aria-label={tipAriaLabel}
          onClick={buttonHandler}
          size="small"
          sx={{ minHeight: 0, minWidth: 0, p: 0 }}
        >
          <Icon color="primary" fill={true} name={iconName} size={20} />
        </IconButton>
      )}
    </Stack>
  )
}
